import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("radio list item", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-radio-list-item></ux-radio-list-item>`);
        const el = await page.find("ux-radio-list-item");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-radio-list-item></ux-radio-list-item>`);
        const el = await page.find("ux-radio-list-item");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with some props", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-radio-list-item value="testvalue" label="label text" name="name-attr" checked disabled>
                Test label
            </ux-radio-list-item>`
        );
        const el = await page.find("ux-radio-list-item");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-radio-list-item value="testvalue" label="label text" name="name-attr" checked disabled>
                Test label
            </ux-radio-list-item>`);
    });
});
